/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Chat,
  ChatMessageInput,
  ChatMessagePosted,
  ChatTaskProgress,
  ChatWrite,
  PaginatedChatList,
  PatchedChat,
} from '../models/index';
import {
    ChatFromJSON,
    ChatToJSON,
    ChatMessageInputFromJSON,
    ChatMessageInputToJSON,
    ChatMessagePostedFromJSON,
    ChatMessagePostedToJSON,
    ChatTaskProgressFromJSON,
    ChatTaskProgressToJSON,
    ChatWriteFromJSON,
    ChatWriteToJSON,
    PaginatedChatListFromJSON,
    PaginatedChatListToJSON,
    PatchedChatFromJSON,
    PatchedChatToJSON,
} from '../models/index';

export interface ChatsCreateRequest {
    chatWrite?: ChatWrite;
}

export interface ChatsDestroyRequest {
    id: string;
}

export interface ChatsListRequest {
    page?: number;
}

export interface ChatsNewMessageRequest {
    id: string;
    chatMessageInput: ChatMessageInput;
}

export interface ChatsPartialUpdateRequest {
    id: string;
    patchedChat?: Omit<PatchedChat, 'id'|'messages'|'created_at'|'updated_at'>;
}

export interface ChatsResponsesRequest {
    id: string;
    taskId: string;
}

export interface ChatsRetrieveRequest {
    id: string;
}

export interface ChatsUpdateRequest {
    id: string;
    chat?: Omit<Chat, 'id'|'messages'|'created_at'|'updated_at'>;
}

/**
 *
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * ViewSet for managing chats
     */
    async chatsCreateRaw(requestParameters: ChatsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Chat>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatWriteToJSON(requestParameters['chatWrite']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsCreate(requestParameters: ChatsCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Chat> {
        const response = await this.chatsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing chats
     */
    async chatsDestroyRaw(requestParameters: ChatsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for managing chats
     */
    async chatsDestroy(requestParameters: ChatsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for managing chats
     */
    async chatsListRaw(requestParameters: ChatsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChatList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChatListFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsList(requestParameters: ChatsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChatList> {
        const response = await this.chatsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new message in the chat
     */
    async chatsNewMessageRaw(requestParameters: ChatsNewMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatMessagePosted>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsNewMessage().'
            );
        }

        if (requestParameters['chatMessageInput'] == null) {
            throw new runtime.RequiredError(
                'chatMessageInput',
                'Required parameter "chatMessageInput" was null or undefined when calling chatsNewMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/new_message/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatMessageInputToJSON(requestParameters['chatMessageInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatMessagePostedFromJSON(jsonValue));
    }

    /**
     * Create a new message in the chat
     */
    async chatsNewMessage(requestParameters: ChatsNewMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatMessagePosted> {
        const response = await this.chatsNewMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing chats
     */
    async chatsPartialUpdateRaw(requestParameters: ChatsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Chat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedChatToJSON(requestParameters['patchedChat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsPartialUpdate(requestParameters: ChatsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Chat> {
        const response = await this.chatsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing chats
     */
    async chatsResponsesRaw(requestParameters: ChatsResponsesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatTaskProgress>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsResponses().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling chatsResponses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/responses/{task_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatTaskProgressFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsResponses(requestParameters: ChatsResponsesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatTaskProgress> {
        const response = await this.chatsResponsesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing chats
     */
    async chatsRetrieveRaw(requestParameters: ChatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Chat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsRetrieve(requestParameters: ChatsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Chat> {
        const response = await this.chatsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for managing chats
     */
    async chatsUpdateRaw(requestParameters: ChatsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Chat>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling chatsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/chat/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChatToJSON(requestParameters['chat']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatFromJSON(jsonValue));
    }

    /**
     * ViewSet for managing chats
     */
    async chatsUpdate(requestParameters: ChatsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Chat> {
        const response = await this.chatsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
